module.exports = __webpack_public_path__ + "static/media/flag-cz.175e8122.webp";